import React, { lazy, Suspense, useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Home from './components/Home';
import Footer from './components/Footer';
import FloatingContactWidget from './components/FloatingContactWidget';
import Analytics from './Analytics';
import { beaches } from './data/beaches';
import { combinedActivities } from './data/activities';
import { villa } from './data/villa';

const WhereToStay = lazy(() => import('./components/WhereToStay'));
const KottiyoorTemple = lazy(() => import('./components/KottiyoorTemple'));
const ExploreKannur = lazy(() => import('./components/ExploreKannur'));

function App() {
  const [contentData] = useState({
    beaches: beaches,
    activities: combinedActivities,
    villa: villa
  });

  // Get referral data on initial load
  const [referrer, setReferrer] = useState('');
  useEffect(() => {
    setReferrer(document.referrer);
  }, []);

  return (
    <>
      <Analytics referrer={referrer} />
      <HelmetProvider>
          <div className="App">
            <ScrollToTop />
            <Navbar />
            
            <Suspense fallback={<div className="loading" />}>
              <Routes>
                <Route
                  path="/"
                  element={<Home />}
                />
                <Route
                  path="/explore-kannur"
                  element={<ExploreKannur beaches={contentData.beaches} activities={contentData.activities} />}
                />
                <Route
                  path="/Grandbeachvilla"
                  element={<WhereToStay villa={contentData.villa} />}
                />
                <Route path="/kottiyoor-temple" element={<KottiyoorTemple />} />
                <Route path="/contact" element={<div>Contact Page</div>} />
                <Route path="/whatsapp-contact" element={<div>WhatsApp Contact Page</div>} />
                <Route path="*" element={<Navigate to="/contact" replace />} />
              </Routes>
            </Suspense>
            
            <Footer />
            
            {/* Global Floating Contact Widget - appears on all pages */}
            <FloatingContactWidget />
          </div>
      </HelmetProvider>
    </>
  );
}

export default App;

